<ng-container [formGroup]="form">
   <div class="checkbox-form-container">
      <mat-form-field>
         <mat-label>Filter by Account</mat-label>
         <input
            autocomplete="off"
            type="text"
            [lcsSingleSelect]="accountSel"
            ndtAccountSelect
            formControlName="value"
            id="user-account"
      /></mat-form-field>
      <ndt-account-select
         #accountSel
         isIncludeEmptyOption="true"
         (optionSelected)="onAccountSelected($event)"
      ></ndt-account-select>
   </div>
</ng-container>
